export default "__VITE_ASSET__328069fb__"